import dbg from "@utils/dbg";

export type ResponseStatus = "success" | "error";

export interface BaseResponse {
  readonly Status: ResponseStatus;
  readonly Errcode?: number;
  readonly Message?: string;
}

// по сути лишний, подстраховка
export interface BaseResponseLowerCase {
  readonly status: ResponseStatus;
  readonly errcode?: number;
  readonly message?: string;
}

export interface RecordResponse<T> extends BaseResponse {
  Record: T;
}
export interface RecordsResponse<T> extends BaseResponse {
  Records: T[];
  Total: number;
}

export interface VtabTotal {
  Id: number;
  Count: number;
};

// all|active|warn|broken|problem|offline racks|store|retired
//export type MinerTabType = "active" | "broken" | "warn" | "unknown" | number;

export type MoveTargetTabType = "broken" | "storage" | "excluded";
export type MinerTabType = "all" | "active" | "warn" | "problem" | "offline" | "racks" | "unknown" | MoveTargetTabType | number;
export const MinerTabsNames: MinerTabType[] = ["broken", "storage", "excluded", "all", "active", "warn", "problem", "offline", "racks", "unknown"];

export interface MinerRecordsResponse<T> extends RecordsResponse<T> {
  Namedtotals: Record<MinerTabType, number>;
}

export const EmptyNamedTotals = Object.fromEntries(MinerTabsNames.map(name => [name, 0])) as Record<MinerTabType, number>;

export const fillNamedTotals = (namedTotals: Record<MinerTabType, number>): Record<MinerTabType, number> => {
  const res = {...namedTotals};
  for (const name of MinerTabsNames) {
    if (!Object.hasOwn(res, name)) res[name] = 0;
  }
  //dbg.trace("FILL", namedTotals, res);
  return res;
}

export class Response {}
